<script setup lang="ts">
import type { PinInputGroupProps } from '.';

import { cn } from '@/utils';
import { Primitive, useForwardProps } from 'reka-ui';
import { computed } from 'vue';

const props = defineProps<PinInputGroupProps>();
const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;
	return delegated;
});
const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<Primitive
		v-bind="forwardedProps"
		:class="cn('flex items-center gap-1', props.class)"
	>
		<slot></slot>
	</Primitive>
</template>
